import { ListMenu } from '../../../utils/common';

// Export the base navigation config without filtering
// The filtering will be done in the Nav component where we have proper state management
const navConfig = ListMenu();

export default navConfig;
